import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PrivateAccountIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 20 20"
    >
      <path
        d="M18.7499 12.6083H18.4332V12.2917C18.4332 10.8583 17.2666 9.69165 15.8332 9.69165C14.3999 9.69165 13.2332 10.8583 13.2332 12.2917V12.6083H12.9166C12.5749 12.6083 12.2832 12.8 12.1249 13.075C11.0832 12.7833 9.94157 12.625 8.74991 12.625C5.56657 12.625 2.7499 13.7333 1.2249 15.5916C0.583238 16.375 0.449905 17.4333 0.883238 18.35C1.3249 19.2917 2.25824 19.875 3.30824 19.875H14.1999C15.1332 19.875 15.9749 19.4083 16.4582 18.65H18.7499C19.2666 18.65 19.6832 18.2333 19.6832 17.7167V13.55C19.6832 13.0333 19.2666 12.6167 18.7499 12.6167V12.6083ZM3.2999 18.625C2.7249 18.625 2.24157 18.325 2.00824 17.8166C1.78324 17.3333 1.8499 16.8 2.18324 16.3833C3.4749 14.8083 5.93324 13.875 8.74991 13.875C9.90824 13.875 10.9999 14.0416 11.9832 14.3416V17.7083C11.9832 18.1917 12.3499 18.5667 12.8166 18.625H3.2999ZM14.2666 12.2917C14.2666 11.4333 14.9666 10.725 15.8332 10.725C16.6999 10.725 17.3999 11.425 17.3999 12.2917V12.6083H14.2749V12.2917H14.2666ZM18.6499 17.6083H13.0249V13.65H18.6499V17.6083Z"
        fill={color}
      />
      <path
        d="M8.7417 11.375C11.8417 11.375 14.3667 8.85 14.3667 5.75C14.3667 2.65 11.8417 0.125 8.7417 0.125C5.6417 0.125 3.1167 2.65 3.1167 5.75C3.1167 8.85 5.6417 11.375 8.7417 11.375ZM8.7417 1.375C11.1584 1.375 13.1167 3.33333 13.1167 5.75C13.1167 8.16667 11.15 10.125 8.7417 10.125C6.33337 10.125 4.3667 8.15833 4.3667 5.75C4.3667 3.34167 6.32503 1.375 8.7417 1.375Z"
        fill={color}
      />
      <path
        d="M15.8334 16.6084C16.3765 16.6084 16.8168 16.1681 16.8168 15.6251C16.8168 15.082 16.3765 14.6417 15.8334 14.6417C15.2904 14.6417 14.8501 15.082 14.8501 15.6251C14.8501 16.1681 15.2904 16.6084 15.8334 16.6084Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PrivateAccountIcon.displayName = 'PrivateAccountIcon';
